import React from 'react';
import Text from 'design-system/Text';
import { IconShieldDone } from 'design-system/icons';
import { Button, CardView, rem, Spacer } from 'design-system';
import { SettingsItemIcon } from 'design-system/SettingsItemIcon';
import { formatPlural } from 'utils';
import useStyles from 'hooks/useStyles';
import { useAppSelector } from 'store/hooks';
import createStyleSheets from 'utils/createStyleSheets';
import { selectTotalBreaches } from '../selectors';
import { useFraudDetection } from './useFraudDetection';
const BreachesDetectedCard = () => {
    const handlePress = useFraudDetection();
    const styles = useStyles(styleSet);
    const breachesInfo = useAppSelector(selectTotalBreaches);
    return (<CardView noMarginTop noMarginBottom withPadding>
      <SettingsItemIcon iconSize={44}>
        <IconShieldDone />
      </SettingsItemIcon>
      <Spacer h={16}/>
      <Text Text-16>
        {breachesInfo.totalNumberOfBreaches}{' '}
        {formatPlural('breach', 'breaches', breachesInfo.totalBreaches)} found
      </Text>
      <Spacer h={4}/>
      <Text TextThin-14 Secondary>
        See what companies have been hacked and have leaked your personal
        information to public databases
      </Text>
      <Spacer h={16}/>
      <Button brandReversed square medium hug onPress={handlePress} containerStyle={styles.setupButton} title="Check details"/>
    </CardView>);
};
export default BreachesDetectedCard;
const styleSet = createStyleSheets(() => ({
    setupButton: {
        alignSelf: 'flex-start',
        paddingHorizontal: rem(24),
    },
}));
